import {AfterViewInit, Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {UserService} from '../../../../_services';
import {ToastService} from '../../../../_services/toast.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LoadingService} from '../../../../_services/loading.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MustMatch} from '../../../../_helpers/match';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from '../../../../_services/storage.service';
import {Platform} from '@ionic/angular';
import {PatternMatch} from '../../../../_helpers/patternMatch';
import {Roles} from '../../../../_model';
import {environment} from '../../../../../environments/environment';


@Component({
  selector: 'app-why-sign-up',
  templateUrl: './sign.up.component.html',
  styleUrls: ['./sign.up.component.scss']
})
export class SignUpComponent implements OnInit, OnChanges, AfterViewInit {
  registerForm: FormGroup;
  submitted = false;
  guestUserObj: any;
  showPassword = false;
  showConfirmPassword = false;

  constructor(private authentication: UserService,
              public toast: ToastService,
              public translate: TranslateService,
              private spinner: LoadingService,
              private platform: Platform,
              private storageService: StorageService,
              private activatedRoute: ActivatedRoute,
              public router: Router) {

    this.registerForm = new FormGroup({
      email: new FormControl('',
        [
          Validators.required,
          Validators.email
        ]),
      password: new FormControl('',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(15),
          // Validators.pattern(/^[A-z0-9]*$/)
          Validators.pattern('^(?=.*\\d)(?=.*[a-z])[\\w~@#$%^&*+=`|{}:;!.?\\"()\\[\\]-]{6,18}$')
        ]),
      confirmPassword: new FormControl('',
        [Validators.required])
    }, {
      validators: [MustMatch('password', 'confirmPassword'),
        PatternMatch('password')]
    });


    // window.visualViewport.addEventListener('resize', this.keyBoardEvent);
  }

  // convenience getter for easy access to form fields
  get field(): any {
    return this.registerForm.controls;
  }

  ngOnInit() {
  }

  onSubmit(): void {
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) {
      return;
    }
    const user = {
      email: this.registerForm.value.email,
      password: this.registerForm.value.password
    };

    const userObj = {
      ...user,
      roles: Roles.user
    };
    this.storageService.set(environment.userObj, userObj);

    this.router.navigate(['./user/auth/about-you']);
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngAfterViewInit(): void {
  }

  togglePassword(event: boolean) {
    this.showPassword = event;
  }

  toggleConfirmPassword($event: boolean) {
    this.showConfirmPassword = $event;
  }
}
